import { Reveal } from "@/components/site/Reveal";
import { MANIFESTO, IMAGES } from "@/lib/data";

export default function Manifesto() {
  return (
    <section className="relative py-28 lg:py-40 max-w-7xl mx-auto px-6 lg:px-10" data-testid="manifesto">
      <Reveal>
        <p className="font-sans text-xs tracking-[0.3em] uppercase text-blush-dusty mb-4">Our Philosophy</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-olive-deep max-w-3xl leading-[1.05]">
          Care that is <span className="italic text-blush-dusty">unhurried</span>, personal and quietly powerful.
        </h2>
      </Reveal>

      <div className="mt-20 grid lg:grid-cols-3 gap-x-10 gap-y-16">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.12} className="border-t border-olive-sage/25 pt-8">
            <span className="font-serif text-6xl text-clay/70 leading-none">{m.n}</span>
            <h3 className="font-serif text-3xl text-olive-deep mt-4">{m.title}</h3>
            <p className="font-sans text-olive-sage mt-4 leading-relaxed">{m.body}</p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-24 relative">
        <div className="grid md:grid-cols-2 gap-6 items-stretch">
          <div className="overflow-hidden rounded-3xl aspect-[16/10] shadow-[0_20px_60px_rgba(47,51,43,0.12)]">
            <img src={IMAGES.clinic2} alt="Clinic lounge" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
          </div>
          <div className="rounded-3xl bg-olive-deep text-cream p-10 lg:p-14 flex flex-col justify-center relative overflow-hidden">
            <div className="absolute -bottom-16 -right-16 w-64 h-64 rounded-full bg-blush-dusty/20 blur-2xl" />
            <p className="font-serif italic text-2xl sm:text-3xl leading-snug relative">
              “Every woman deserves to be truly heard. At Asmi, your story shapes your care.”
            </p>
            <p className="font-sans text-sm tracking-widest uppercase text-beige mt-8 relative">— Dr. Shivani Jain</p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
